import React, { Component } from 'react'
import { connect } from 'react-redux'
import Toggle from 'material-ui/Toggle';
import {api} from "../../../../../../../api";

class PromotionVariantActionsTop extends Component {
	constructor(props) {
		super(props);

		this.handleToggle = this.handleToggle.bind( this );
	}

	handleToggle( event, isChecked ) {

		const active = true === isChecked ? true : false;

		this.props.handleActive(active);
	}

	duplicateVariant( variant, periodKey ) {
		let newVariant = {
			...variant
		};

		delete newVariant.key;
		delete newVariant.periodId;

		api.promotions.addPeriodVariantAction( periodKey, newVariant );
	}

	render() {

		const variant = this.props.promotion.periods[this.props.periodKey].variants[this.props.variantKey];
		const active = undefined === variant.active || true === variant.active;

		return (
			<div className="grid-x grid-margin-y grid-padding-x grid-margin-x">
				<div className="medium-6 cell">
					<Toggle
						label={active ? 'Actief' : 'Inactief'}
						labelPosition="right"
						onToggle={this.handleToggle}
						toggled={active}
					/>
				</div>
				<div className="medium-6 cell text-right">
					<button
						className="promotion__variation__duplicate"
						onClick={(event) => {
							event.preventDefault();
							this.duplicateVariant(variant, this.props.periodKey )
						}}
					/>
					<button
						className="promotion__variation__delete"
						onClick={this.props.removeVariation.bind(null, this.props.periodKey, this.props.variantKey, variant)}
					/>
				</div>
			</div>

		);
	}
}

const mapStateToProps = ( state ) => {
	return {
		promotion: state.promotion
	}
}

export default connect(mapStateToProps)(PromotionVariantActionsTop)


// WEBPACK FOOTER //
// ./src/application/components/promotions/components/types/variants/includes/actionsTop.js